(function () {
  var CFG = window.ccConfig;
  var root = document.getElementById('cc-cart');
  if (!CFG || !root) return;

  // Tout vient de Shopify : données synchronisées (cc_config) + règles modifiables (cc_rules).
  (function normalize() {
    var D = CFG.data || {}, R = CFG.regles || {};
    var ship = D.shipping || {}, country = (window.Shopify && window.Shopify.country) || 'FR';
    var s = ship[country] || ship.FR || [7900, 1000];
    CFG.franco = s[0]; CFG.shipping = s[1];
    CFG.promo = D.promo || { programs: [] };
    CFG.names = D.names || {};
    CFG.strip = D.strip || [];
    CFG.flash = D.flash || [];
    CFG.stripMax = Math.max(R.suggestions_max || 0, 10);
    CFG.oxyNeed = R.oxydant_litres_par_unite || {};
    CFG.oxyForce = R.oxydant_force || {};
    CFG.pumpOnly = R.pompe_imposee || [];
    CFG.units = R.unites || {};
    CFG.forceProducts = R.produits_a_forces || [];
    CFG.gifts = R.paliers_cadeaux || [];
    CFG.gammes = R.panier_vide_gammes || [];
    CFG.maxq = R.max_par_commande || {};   // product_id → quantité maximale par commande (ex. colis mystère = 1)
    var labels = R.oubli_libelles || {};
    CFG.rules = {};
    Object.keys(D.pairs || {}).forEach(function (pid) {
      var t = D.pairs[pid], n = CFG.names[t.productId];
      CFG.rules[pid] = { productId: t.productId, variantId: t.variantId, label: labels[t.productId] || (n ? n[0] : 'ce produit') };
    });
  })();

  var nativeFetch = window.fetch.bind(window);
  function T() { try { (window.__ccq = window.__ccq || []).push([].slice.call(arguments)); } catch (e) {} }
  var cart = null;
  var busy = false;
  var open_ = {};        // groupes de variantes dépliés, par product_id
  var oc = {};           // produits ajoutés via « N'oubliez pas ces produits »
  var vp = null;         // panneau des variantes ouvert
  var productCache = {};
  var prev = null;       // état précédent pour les power-up / power-down
  var quiet = true;
  var lastTap = null;

  function $(sel) { return root.querySelector(sel); }
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function has(list, id) { return list.indexOf(+id) !== -1; }
  function isHidden(item) {
    if (item.variant_id === CFG.gasoilVariantId || isCE(item)) return true;
    return CFG.hiddenHandles.some(function (h) { return item.handle && item.handle.indexOf(h) !== -1; });
  }
  function isGasoil(item) { return item.variant_id === CFG.gasoilVariantId; }
  // Carte essence (window.ccEssence, snippet cc-essence) : une carte offerte par tranche de CE.seuil de produits éligibles, prix payé HT
  var CE = window.ccEssence || null;
  function isCE(item) { return !!CE && item.variant_id === CE.variant; }
  function ceSum(c) { return CE ? c.items.filter(function (i) { return !isHidden(i) && has(CE.ids, i.product_id); }).reduce(function (a, i) { return a + i.final_line_price; }, 0) : 0; }
  function ceWant(c) { return CE && CE.actif() ? Math.floor(ceSum(c) / CE.seuil) : 0; }
  function unit(pid, n) { var u = CFG.units[pid] || ['article', 'articles']; return n > 1 ? u[1] : u[0]; }
  function cleanVariant(t) { return String(t || '').replace(/\s*-\s*[\d.,]+\s*€\s*ht\s*$/i, '').replace(/\s+-(?=\S)/, ' - '); }
  function img(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function variantLabel(pid) {
    if (has(CFG.forceProducts, pid)) return '+ Ajouter une force';
    if (CFG.units[pid] && CFG.units[pid][0] === 'tube') return '+ Ajouter des nuances';
    return '+ Ajouter une variante';
  }

  function api(path, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return nativeFetch(path, opts).then(function (r) {
      if (!r.ok) T('erreur', 'api_panier', path.split('?')[0], { statut: r.status, articles: body && body.items ? body.items.length : undefined });
      return r.json();
    });
  }
  // Pack d'implantation : le nuancier du pack s'affiche toujours offert dans le panier ; c'est la remise
  // automatique (Shopify Function pack-nuancier-offert) qui vérifie au paiement si le client y a droit.
  var PACK_NUANCIER = 48863649956167;
  function packGift(c) {
    (c && c.items || []).forEach(function (i) {
      if (i.variant_id !== PACK_NUANCIER || !i.properties || i.properties._pack !== 'implantation' || i.final_line_price <= 0) return;
      var d = i.final_line_price;
      i.final_line_price = 0; i.final_price = 0;
      c.total_price -= d; c.items_subtotal_price -= d;
    });
    return c;
  }
  function getCart() { return api('/cart.js?cc=' + Date.now()).then(packGift); }
  function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = api('/products/' + handle + '.js');
    return productCache[handle];
  }
  // Prix barré (compare_at) : absent de /cart.js. Pré-rempli par Liquid (panier au chargement + oxydant),
  // sinon lu sur la fiche produit des lignes ajoutées ensuite (cache, nouvel essai si l'appel échoue).
  var cmp = CFG.cmp || {}, cmpSeen = {};
  function loadCmp() {
    var hs = [];
    visible().forEach(function (i) { if (!(i.variant_id in cmp) && i.handle && !cmpSeen[i.handle]) { cmpSeen[i.handle] = 1; hs.push(i.handle); } });
    if (!hs.length) return;
    var found = false;
    Promise.all(hs.map(function (h) {
      return getProduct(h).then(function (p) {
        (p.variants || []).forEach(function (v) { cmp[v.id] = v.compare_at_price > v.price ? v.compare_at_price : 0; if (cmp[v.id]) found = true; });
      }, function () { delete productCache[h]; }); // produit introuvable (brouillon, supprimé) : pas de nouvel essai sur cette page
    })).then(function () { if (found) render(); });
  }

  // Taxe gasoil : exactement 1 dès qu'il y a un produit, 0 sinon.
  // Les corrections passent une par une et relisent le panier : deux appels simultanés
  // (ouverture du panier + détection d'un ajout externe) ajoutaient sinon la taxe deux fois.
  function gasoilGap(c) {
    var others = c.items.filter(function (i) { return !isHidden(i); }).length;
    var line = c.items.filter(isGasoil)[0];
    var want = others > 0 ? 1 : 0;
    var have = line ? line.quantity : 0;
    return want === have ? null : { line: line, want: want, have: have };
  }
  var gasoilQueue = Promise.resolve();
  function ensureGasoil(c) {
    if (!gasoilGap(c)) return Promise.resolve(c);
    var p = gasoilQueue.then(getCart).then(function (fresh) {
      var g = gasoilGap(fresh);
      if (!g) return fresh;
      var req = g.have === 0
        ? api('/cart/add.js', { items: [{ id: CFG.gasoilVariantId, quantity: 1 }] })
        : api('/cart/change.js', { id: g.line.key, quantity: g.want });
      return req.then(getCart);
    });
    gasoilQueue = p.catch(function () {});
    return p;
  }

  function ceGap(c) {
    var line = c.items.filter(isCE)[0], want = ceWant(c), have = line ? line.quantity : 0;
    return want === have ? null : { line: line, want: want, have: have };
  }
  function ensureCE(c) {
    if (!CE || !ceGap(c)) return Promise.resolve(c);
    var p = gasoilQueue.then(getCart).then(function (fresh) {
      var g = ceGap(fresh);
      if (!g) return fresh;
      var req = g.have === 0
        ? api('/cart/add.js', { items: [{ id: CE.variant, quantity: g.want }] })
        : api('/cart/change.js', { id: g.line.key, quantity: g.want });
      return req.then(getCart);
    });
    gasoilQueue = p.catch(function () {});
    return p;
  }
  function ensureFees(c) { return ensureGasoil(c).then(ensureCE); }

  function run(promise) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('cc-busy');
    // /cart/add.js ne renvoie que les articles ajoutés : on relit le panier complet avant de vérifier la taxe gasoil.
    return promise
      .then(function () { return getCart(); })
      .then(ensureFees)
      .then(function (c) { cart = c; render(); })
      .finally(function () { busy = false; root.classList.remove('cc-busy'); });
  }
  function sync(silent) {
    return getCart().then(ensureFees).then(function (c) {
      cart = c;
      if (silent) quiet = true;
      render();
      quiet = false;
      return c;
    });
  }

  /* ---------- calculs ---------- */
  function visible() { return cart ? cart.items.filter(function (i) { return !isHidden(i); }) : []; }
  function qtyOfProduct(pid) { return visible().filter(function (i) { return i.product_id === +pid; }).reduce(function (a, i) { return a + i.quantity; }, 0); }
  function stats() {
    var items = visible();
    var sub = 0, orig = 0, need = 0, oxy = 0, count = 0, byForce = {};
    items.forEach(function (i) {
      sub += i.final_line_price; orig += Math.max(i.original_line_price, wasOf(i) * i.quantity); count += i.quantity;
      if (CFG.oxyNeed[i.product_id]) {
        var l = CFG.oxyNeed[i.product_id] * i.quantity, f = CFG.oxyForce[i.product_id] || 20;
        need += l; byForce[f] = (byForce[f] || 0) + l;
      }
      if (i.product_id === CFG.oxy.productId) oxy += i.quantity;
    });
    var cartLevel = cart ? (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0) : 0;
    // Promos à paliers synchronisées depuis les remises automatiques Shopify (shop.metafields.custom.cc_promo)
    var progs = promoPrograms().map(function (pg) {
      var qty = items.filter(function (i) { return has(pg.productIds, i.product_id); }).reduce(function (a, i) { return a + i.quantity; }, 0);
      var next = null;
      pg.tiers.forEach(function (t) { if (qty < t[0] && !next) next = t; });
      return { productIds: pg.productIds, qty: qty, next: next };
    });
    return { items: items, count: count, orig: orig, sub: sub - cartLevel, disc: orig - sub + cartLevel, progs: progs,
      need: Math.round(need * 10) / 10, needL: Math.ceil(need - 1e-9), oxy: oxy, byForce: byForce };
  }

  /* ---------- rendu ---------- */
  // Quantité maximale par commande (cc_rules.max_par_commande) : une ligne qui dépasse (page /cart native, double ajout) est ramenée au maximum.
  var fixing = false;
  function render() {
    if (cart && !fixing) {
      var fix = {}, over = null;
      cart.items.forEach(function (i) { var mx = maxOf(i.product_id); if (mx && i.quantity > mx) { fix[i.key] = mx; over = i; } });
      if (over) {
        fixing = true;
        api('/cart/update.js', { updates: fix }).then(getCart).then(ensureFees).then(function (c) { cart = c; }).catch(function () {})
          .then(function () { fixing = false; toast('Maximum ' + maxOf(over.product_id) + ' par commande : ' + nameOf(over.product_id, over.product_title)); render(); });
        return;
      }
    }
    var k = stats();
    $('.cc-count').textContent = k.count ? k.count + (k.count > 1 ? ' articles' : ' article') : '';
    $('.cc-empty').hidden = k.count > 0;
    remember(k);
    $('.cc-empty').innerHTML = k.count ? '' : emptyView();
    $('.cc-foot').classList.toggle('cc-foot-empty', k.count === 0);

    var left = CFG.franco - k.sub;
    $('.cc-fs').innerHTML = fsBlock(k, left);

    $('.cc-oxy').innerHTML = oxyBlock(k);
    if (k.need && k.oxy < k.needL) T('panier', 'alerte_oxydant_vue', null, { besoin_l: k.need, au_panier_l: k.oxy, par_force: JSON.stringify(k.byForce) }, 'oxy' + k.need);
    $('.cc-lines').innerHTML = ceBlock(k) + lines(k);
    $('.cc-oc').innerHTML = strip(k, left);

    var ship = left > 0 ? money(CFG.shipping) + ' HT' : '<s>' + money(CFG.shipping) + '</s> <span class="cc-free">Offerte</span>';
    $('.cc-sum').innerHTML = !k.count ? '' :
      '<div><span>Produits</span><span>' + money(k.orig) + '</span></div>' +
      (k.disc > 0 ? '<div class="cc-disc"><span>Remises</span><span class="cc-sum-rem">−' + money(k.disc) + '</span></div>' : '') +
      '<div><span>Livraison</span><span>' + ship + '</span></div>' +
      (ceWant(cart) ? '<div class="cc-ce-sum"><span>Carte essence</span><span><b>' + ceWant(cart) * CE.valeur + ' €</b> offerts</span></div>' : '') +
      '<div class="cc-sum-tot"><span>Total</span><b>' + money(k.sub + (left > 0 ? CFG.shipping : 0)) + ' HT</b></div>';

    powerFx(k);
    loadCmp();
    if (typeof nvd_init === 'function') { try { nvd_init(); } catch (e) {} }
  }

  var oxyP = null, oxyLoading = false;
  function oxyPlan(k) {
    if (!oxyP) {
      if (!oxyLoading) { oxyLoading = true; getProduct(CFG.oxy.handle).then(function (p) { oxyP = p; render(); }, function () { oxyLoading = false; }); }
      return null;
    }
    var have = {}, plan = [];
    visible().forEach(function (i) { if (i.product_id === CFG.oxy.productId) have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
    Object.keys(k.byForce).sort(function (a, b) { return b - a; }).forEach(function (f) {
      var v = oxyP.variants.find(function (x) { return parseInt(x.title, 10) === +f && x.available; });
      if (!v) return;
      var miss = Math.ceil(k.byForce[f] - 1e-9) - (have[v.id] || 0);
      if (miss > 0) plan.push({ id: v.id, quantity: miss, f: +f, price: v.price });
    });
    if (!plan.length && k.needL > k.oxy) {
      var d = oxyP.variants.find(function (x) { return x.id === CFG.oxy.defaultVariantId; });
      if (d) plan.push({ id: d.id, quantity: k.needL - k.oxy, f: parseInt(d.title, 10), price: d.price });
    }
    return plan;
  }
  function oxyBlock(k) {
    if (!k.need || k.oxy >= k.needL) return '';
    var miss = Math.max(0, Math.round((k.need - k.oxy) * 10) / 10), plan = oxyPlan(k), ok = plan && plan.length;
    var sub = ok ? plan.map(function (x) { return x.quantity + ' × EasyOxy ' + x.f + ' vol'; }).join(' + ') + ' (1 L) · ' +
      money(plan.reduce(function (a, x) { return a + x.price * x.quantity; }, 0)) + ' HT' : 'Choisir les forces et les quantités';
    return '<div class="cc-ox1"><span class="cc-warn">' + WARN + '</span>' +
      '<button type="button" class="cc-ox1-t" data-cc-oxy><b>Il vous manque ' + String(miss).replace('.', ',') + ' L d\'oxydant</b><span>' + sub + '</span></button>' +
      '<button type="button" class="cc-ox1-add" ' + (ok ? 'data-cc-oxyadd' : 'data-cc-oxy') + '>Ajouter</button></div>';
  }


  // Colonne de droite : montant de la ligne, et dessous prix barré + remise si promo.
  function priceBlock(fin, was) {
    return '<span class="cc-price">' + money(fin) + '</span>' + (was > fin ? '<span class="cc-was"><s>' + money(was) + '</s><span class="cc-pbadge">−' + Math.round((1 - fin / was) * 100) + ' %</span></span>' : '');
  }
  function priceHtml(item, k) {
    return priceBlock(item.final_line_price, wasOf(item) * item.quantity);
  }
  // Ordre du nuancier : 1, 1.10, 3, 4, 4.15, 4.20, 4.3 … 12, 12.1 (partie entière numérique, décimales comme texte).
  function shadeKey(title) {
    var m = String(title || '').match(/^\s*(\d+)(?:\.(\d+))?/);
    return m ? [0, +m[1], m[2] || ''] : [1, 0, String(title || '')];
  }
  function byShade(a, b) {
    var x = shadeKey(a.variant_title), y = shadeKey(b.variant_title);
    for (var i = 0; i < 3; i++) { if (x[i] < y[i]) return -1; if (x[i] > y[i]) return 1; }
    return 0;
  }
  // Nom court + descriptif (champs Shopify « Nom court » / « Descriptif court »), sinon le titre complet.
  function nameOf(pid, fallback) { var n = (CFG.names || {})[pid]; return n ? n[0] : fallback; }
  function descOf(pid) { var n = (CFG.names || {})[pid]; return n && n[1] ? '<span class="cc-d">' + esc(n[1]) + '</span>' : ''; }
  function wasOf(item) { return Math.max(item.original_price, cmp[item.variant_id] || 0); }


  function promoPrograms() { return (CFG.promo && CFG.promo.programs) || []; }
  var promoAt = {};   // product_id → promo à paliers : l'alerte s'affiche sur chaque produit de la promo
  // Variante unique (EasyBlond, FULLBLOND…) : ajout direct des unités manquantes ; sinon panneau des variantes.
  function palierAttr(pid, handle, n) {
    var it = visible().filter(function (i) { return i.product_id === pid; })[0];
    return it && it.product_has_only_default_variant ? 'data-cc-addq="' + it.variant_id + '" data-q="' + n + '"' : 'data-cc-vp="' + esc(handle) + '"';
  }
  function promoAlert(pid, handle, k) {
    // Palier le plus proche : remise suivante (promo à paliers) ou cadeau (cc_rules.paliers_cadeaux, appli BOGOS).
    var c = [], pg = k.progs.filter(function (p) { return promoAt[pid] === p && p.next && p.qty > 0; })[0];
    if (pg) c.push({ n: pg.next[0] - pg.qty, quoi: 'pour −' + pg.next[1] + ' %' });
    CFG.gifts.forEach(function (g) {
      if (!has(g.produits, pid)) return;
      var q = k.items.filter(function (i) { return has(g.produits, i.product_id); }).reduce(function (a, i) { return a + i.quantity; }, 0);
      if (q > 0 && q < g.quantite) c.push({ n: g.quantite - q, quoi: '= ' + g.libelle });
    });
    if (!c.length) return '';
    c.sort(function (a, b) { return a.n - b.n; });
    var n = c[0].n;
    T('panier', 'palier_vu', c[0].quoi, { produit_id: pid, manquant: n }, 'pal' + pid + '-' + n);
    return '<button type="button" class="cc-fg" ' + palierAttr(pid, handle, n) + '>' + PLUSC + '<span>Ajouter ' + n + ' ' + unit(pid, n) + ' ' + esc(c[0].quoi) + '</span></button>';
  }

  function priceGroupHtml(rows, pid, k) {
    var fin = rows.reduce(function (a, i) { return a + i.final_line_price; }, 0);
    return priceBlock(fin, rows.reduce(function (a, i) { return a + wasOf(i) * i.quantity; }, 0));
  }

  function maxOf(pid) { return +CFG.maxq[pid] || 0; }
  function stepper(key, q, pid) {
    var mx = pid != null ? maxOf(pid) : 0;
    return '<span class="cc-step"><button type="button" data-cc-q="-1" data-key="' + esc(key) + '" aria-label="Retirer un">−</button>' +
      '<span class="cc-qv">' + q + '</span><button type="button" data-cc-q="1" data-key="' + esc(key) + '"' + (mx && q >= mx ? ' disabled title="Maximum ' + mx + ' par commande"' : '') + ' aria-label="Ajouter un">+</button></span>' +
      (mx && q >= mx ? '<span class="cc-maxq">' + mx + ' max. par commande</span>' : '');
  }
  function forgot(pid) {
    var r = CFG.rules[pid];
    if (!r || qtyOfProduct(r.productId)) return '';
    T('panier', 'oubli_vu', r.label, { produit_id: r.productId, depuis_id: +pid }, 'oubli' + r.productId);
    return '<button type="button" class="cc-fg" data-cc-forgot="' + r.variantId + '">' + PLUSC + '<span>Ajouter ' + esc(r.label) + '</span></button>';
  }

  // Les produits déjà présents gardent leur place ; un nouveau produit s'ajoute en haut.
  // Shopify remonte en tête toute ligne modifiée (nuance ajoutée, quantité) : sans ça, tout bougerait.
  var ORDER_KEY = 'cc-order';
  function stableOrder(pids) {
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(ORDER_KEY) || '[]'); } catch (e) {}
    var kept = saved.filter(function (id) { return pids.indexOf(id) !== -1; });
    var order = pids.filter(function (id) { return kept.indexOf(id) === -1; }).concat(kept);
    try { localStorage.setItem(ORDER_KEY, JSON.stringify(order)); } catch (e) {}
    return order;
  }
  function ceBlock(k) {
    if (!CE || !CE.actif() || !k.count) return '';
    var sum = ceSum(cart), n = Math.floor(sum / CE.seuil), rest = CE.seuil - sum % CE.seuil;
    var pct = Math.round(sum % CE.seuil / CE.seuil * 100);
    T('essence', 'panier_vu', null, { cartes: n, eligible: sum / 100 }, 'ce' + n);
    var msg = n
      ? 'Plus que <b>' + money(rest) + ' HT</b> de produits Coiffissimo pour obtenir votre ' + (n + 1) + 'e carte essence offerte'
      : 'Plus que <b>' + money(rest) + ' HT</b> de produits Coiffissimo pour recevoir votre carte essence d\'une valeur de ' + CE.valeur + ' €';
    var stack = '';
    for (var i = Math.min(Math.max(n, 1), 5) - 1; i >= 0; i--) stack += '<img class="cc-ce-i" src="' + CE.carte + '" alt="" width="64" height="40" style="--i:' + i + '">';
    return '<div class="cc-ce' + (n ? ' cc-ce-on' : '') + '"><span class="cc-ce-st" style="--n:' + Math.min(Math.max(n, 1), 5) + '">' + stack +
      (n ? '<b class="cc-ce-tot"><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 9.5h17v3.5h-17zM5 13v7.5h14V13M12 9.5v11M12 9.5C10 9.5 7 9 7 6.8 7 5.5 8 4.6 9.2 4.8 11 5.1 12 9.5 12 9.5zM12 9.5c2 0 5-.5 5-2.7 0-1.3-1-2.2-2.2-2 -1.8.3-2.8 4.7-2.8 4.7z" stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="round"/></svg>' + n * CE.valeur + ' €</b>' : '') + '</span>' +
      '<div class="cc-ce-b"><div class="cc-ce-t"><b>Votre plein d\'essence offert</b><button type="button" class="cc-ce-how" data-ce-open="panier"><span class="cc-ce-how-d">Comment ça marche ?</span><span class="cc-ce-how-m"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M12 11v6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><circle cx="12" cy="7.3" r="1.5" fill="currentColor"/></svg>Plus d\'info</span></button></div>' +
      (n ? '<div class="cc-ce-n"><span>Carte essence ' + CE.valeur + ' € × ' + n + '</span><span class="cc-ce-off">' + (n > 1 ? 'OFFERTES' : 'OFFERTE') + '</span></div>' : '') +
      '<p class="cc-ce-m">' + msg + '</p><div class="cc-ce-bar"><i style="width:' + pct + '%"></i></div></div></div>';
  }
  function lines(k) {
    var groups = [], byPid = {};
    k.items.forEach(function (i) {
      if (!byPid[i.product_id]) { byPid[i.product_id] = []; groups.push(i.product_id); }
      byPid[i.product_id].push(i);
    });
    groups = stableOrder(groups);
    // le message de palier de chaque promo se place sous la dernière ligne concernée de la liste
    promoAt = {};
    k.progs.forEach(function (pg) { groups.forEach(function (pid) { if (has(pg.productIds, pid)) promoAt[pid] = pg; }); });
    return groups.map(function (pid) {
      var rows = byPid[pid], first = rows[0];
      var multi = !first.product_has_only_default_variant;
      var canAdd = multi && !has(CFG.pumpOnly, pid);
      var q = rows.reduce(function (a, i) { return a + i.quantity; }, 0);
      var thumb = '<img class="cc-thumb" src="' + esc(img(first.featured_image && first.featured_image.url ? first.featured_image.url : first.image, 160)) + '" alt="" width="64" height="64" loading="lazy">';
      var removeKeys = rows.map(function (i) { return i.key; }).join(',');
      var x = '<button type="button" class="cc-rm" data-cc-rm="' + esc(removeKeys) + '" aria-label="Retirer ' + esc(first.product_title) + '"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1.5 1.5l9 9M10.5 1.5l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>';
      var link = canAdd ? '<button type="button" class="cc-link" data-cc-vp="' + esc(first.handle) + '">' + variantLabel(pid) + '</button>' : '';

      if (rows.every(function (i) { return i.final_line_price === 0; })) {
        return '<div class="cc-line cc-gift">' + thumb + '<div class="cc-info"><span class="cc-t">' + esc(nameOf(pid, first.product_title.replace(/^\s*🎁\s*/, '').replace(/\s*\(100% off\)\s*$/i, ''))) + '</span>' + descOf(pid) +
          '<span class="cc-v">Cadeau offert</span>' +
          '<div class="cc-row"><div class="cc-lft"><span class="cc-step off" aria-label="Quantité offerte : ' + q + '"><button type="button" disabled tabindex="-1" aria-hidden="true">−</button><span class="cc-qv">' + q + '</span><button type="button" disabled tabindex="-1" aria-hidden="true">+</button></span></div><div class="cc-pr"><span class="cc-price">' + (first.original_line_price > 0 ? '<s>' + money(first.original_line_price) + '</s> ' : '') + '<span class="cc-free">Offert</span></span></div></div></div></div>';
      }
      if (rows.length === 1) {
        var sub = multi ? esc(cleanVariant(first.variant_title)) : '';
        return '<div class="cc-line">' + thumb + '<div class="cc-info"><div class="cc-tl"><a class="cc-t" href="' + esc(first.url) + '">' + esc(nameOf(pid, first.product_title)) + '</a>' + forgot(pid) + promoAlert(pid, first.handle, k) + '</div>' + descOf(pid) +
          (sub ? '<span class="cc-v">' + sub + '</span>' : '') +
          '<div class="cc-row"><div class="cc-lft">' + stepper(first.key, first.quantity, pid) + '</div><div class="cc-pr">' + priceHtml(first, k) + '</div></div>' +
          (link ? '<div class="cc-under">' + link + '</div>' : '') +
          '</div>' + x + '</div>';
      }
      var isOpen = !!open_[pid];
      var shades = !isOpen ? '' : '<div class="cc-shades">' + rows.slice().sort(byShade).map(function (i) {
        return '<div class="cc-shade">' + (i.image ? '<img class="cc-sw" src="' + esc(img(i.image, 60)) + '" alt="">' : '') +
          '<span class="cc-sn">' + esc(cleanVariant(i.variant_title)) + '</span>' + stepper(i.key, i.quantity) +
          '<span class="cc-sp">' + money(i.final_line_price) + '</span></div>';
      }).join('') + (canAdd ? '<button type="button" class="cc-shade cc-shade-add" data-cc-vp="' + esc(first.handle) + '"><span class="cc-sw-plus" aria-hidden="true">+</span><span class="cc-sn">' + (has(CFG.forceProducts, pid) ? 'Ajouter d\'autres forces' : 'Ajouter plus de nuances') + '</span></button>' : '') + '</div>';
      return '<div class="cc-line">' + thumb + '<div class="cc-info"><div class="cc-tl"><a class="cc-t" href="' + esc(first.url) + '">' + esc(nameOf(pid, first.product_title)) + '</a>' + forgot(pid) + promoAlert(pid, first.handle, k) + '</div>' + descOf(pid) +
        '<div class="cc-row"><div class="cc-lft"><button type="button" class="cc-tog" data-cc-tog="' + pid + '" aria-expanded="' + isOpen + '">' + q + ' ' + unit(pid, q) + ' · ' + rows.length + ' ' + (has(CFG.forceProducts, pid) ? (rows.length > 1 ? 'forces' : 'force') : (rows.length > 1 ? 'nuances' : 'nuance')) +
        ' <svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg></button>' + (canAdd ? '<button type="button" class="cc-link" data-cc-vp="' + esc(first.handle) + '">+ Ajouter</button>' : '') + '</div>' +
        '<div class="cc-pr">' + priceGroupHtml(rows, pid, k) + '</div></div>' +
        '</div>' + x + shades + '</div>';
    }).join('');
  }

  function forgotTargets() {
    var t = [];
    visible().forEach(function (i) { var r = CFG.rules[i.product_id]; if (r && !qtyOfProduct(r.productId)) t.push(r.productId); });
    return t;
  }
  var PLUSC = '<svg viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7 4.2v5.6M4.2 7h5.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 2.5v9M2.5 7h9"/></svg>';
  var CHK = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 7.3l2.6 2.6L11 4.5"/></svg>';
  var BAG = '<svg class="cc-e0-ic" width="34" height="34" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6"/><circle cx="9.5" cy="20" r="1.2"/><circle cx="17" cy="20" r="1.2"/></svg>';
  var TRUCK = '<svg class="cc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9.5h-11zM13.5 9.5h4l3.5 3.6V16h-7.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
  function eur0(c) { return money(c).replace(/,00(\s€)$/, '$1'); }
  function nocur(c) { return money(c).replace(/\s€$/, ''); }
  function big(src) { return String(src || '').replace(/([?&])width=\d+/, '$1width=200'); }
  function fsBlock(k, left) {
    if (!k.count) return '';
    var p = Math.min(100, k.sub / CFG.franco * 100);
    if (left > 0) return '<p class="cc-fs-l"><span>Plus que <b>' + money(left) + '</b> pour la livraison offerte (−' + eur0(CFG.shipping) + ')</span></p><i class="cc-fs-bar"><b style="width:' + p + '%"></b></i>';
    return '<p class="cc-fs-l ok"><span>' + CHK + '<b>Livraison offerte</b> · ' + eur0(CFG.shipping) + ' économisés</span></p><i class="cc-fs-bar ok"><b style="width:100%"></b></i>';
  }

  function strip(k, left) {
    var ft = forgotTargets(), seen = {};
    var flash = CFG.flash.filter(function (s) { return oc[s.productId] || !qtyOfProduct(s.productId); });
    var list = flash.map(function (s) { return { s: s, fl: true }; })
      .concat(CFG.strip.filter(function (s) { return oc[s.productId] || (!qtyOfProduct(s.productId) && ft.indexOf(s.productId) === -1); }).map(function (s) { return { s: s }; }))
      .filter(function (x) { if (seen[x.s.productId]) return false; seen[x.s.productId] = 1; return true; })
      .slice(0, CFG.stripMax);
    if (!list.length || !visible().length) return '';
    T('panier', 'suggestions_vues', null, { produits: list.map(function (x) { return x.s.productId; }).join(','), promo: flash.length }, 'sv' + list.map(function (x) { return x.s.productId; }).join(','));
    return '<div class="cc-oc-h">Complétez votre commande</div><div class="cc-rr">' +
      list.map(function (x) {
        var s = x.s, on = !!oc[s.productId] && qtyOfProduct(s.productId) > 0;
        var was = x.fl ? s.price : cmp[s.variantId] || 0, now = x.fl ? s.now : s.price, promo = !on && was > now;
        var pr = on ? 'Ajouté' : promo ? '<span class="cc-rc-pp">−' + Math.round((1 - now / was) * 100) + ' % <s>' + nocur(was) + '</s></span><b>' + money(now) + '</b>' : money(now);
        var badge = !on && !promo && s.badge === 'Nouveau' ? '<span class="cc-rc-b new">Nouveau</span>' : '';
        return '<div class="cc-rc' + (on ? ' on' : '') + '"><div class="cc-rc-i"><img src="' + esc(big(s.image)) + '" alt="" width="80" height="80" loading="lazy">' + badge +
          '<button type="button" class="cc-rc-add" data-cc-rc="' + s.productId + '" data-vid="' + s.variantId + '" data-promo="' + (x.fl ? s.pct : '') + '" data-name="' + esc(s.name) + '" aria-label="' + (on ? 'Retirer ' : 'Ajouter ') + esc(s.name) + '">' + (on ? CHK : PLUS) + '</button><span class="cc-rc-p' + (on ? ' ok' : promo ? ' promo' : '') + '">' + pr + '</span></div>' +
          '<b>' + esc(s.name).replace(/ (\d+(?:[.,]\d+)?) (\S{1,3})$/, ' $1\u00a0$2') + '</b></div>';
      }).join('') + '</div>';
  }


  /* ---------- panier vide : idées d'achat + dernier panier de ce navigateur ---------- */
  // Pas de compte client : le dernier panier vit dans localStorage. cc-cur suit le panier en cours ;
  // s'il est trouvé vide au premier affichage (commande passée, panier expiré), il devient cc-last.
  // Vidé à la main pendant la visite : il est oublié.
  var CUR_KEY = 'cc-cur', LAST_KEY = 'cc-last', seen = false;
  function lsGet(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function lsSet(key, v) { try { if (v) localStorage.setItem(key, JSON.stringify(v)); else localStorage.removeItem(key); } catch (e) {} }
  function remember(k) {
    var first = !seen; seen = true;
    if (!k.count) {
      if (first) { var cur = lsGet(CUR_KEY); if (cur) { lsSet(LAST_KEY, cur); lsSet(CUR_KEY, null); } }
      else if (prev && prev.count) lsSet(CUR_KEY, null);
      return;
    }
    var paid = k.items.filter(function (i) { return i.final_line_price > 0; });
    if (!paid.length) return;
    var imgs = [];
    paid.forEach(function (i) { var u = i.featured_image && i.featured_image.url ? i.featured_image.url : i.image; if (u && imgs.length < 3 && imgs.indexOf(u) === -1) imgs.push(u); });
    lsSet(CUR_KEY, { at: Date.now(), count: paid.reduce(function (a, i) { return a + i.quantity; }, 0), total: k.sub, imgs: imgs,
      items: paid.map(function (i) { return { id: i.variant_id, quantity: i.quantity }; }) });
  }
  function emptyView() {
    var last = lsGet(LAST_KEY);
    var flash = CFG.flash.slice(0, 2), fids = flash.map(function (s) { return s.productId; });
    var top = CFG.strip.filter(function (s) { return fids.indexOf(s.productId) === -1; }).slice(0, 6);
    T('panier', 'vide_vu', null, { promo: flash.length, dernier: last ? 1 : 0 }, 'vide');
    var h = '<div class="cc-e0">' + BAG + '<div><b>Votre panier est vide</b><span>Livraison offerte dès ' + eur0(CFG.franco) + ' HT</span></div></div>';
    if (last && last.items && last.items.length) {
      h += '<div class="cc-elast"><div class="cc-elast-i">' + (last.imgs || []).map(function (u) { return '<img src="' + esc(img(u, 120)) + '" alt="" width="34" height="34" loading="lazy">'; }).join('') + '</div>' +
        '<b>Votre panier du ' + new Date(last.at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }) + '</b>' +
        '<small>' + last.count + ' article' + (last.count > 1 ? 's' : '') + ' · ' + money(last.total) + ' HT</small>' +
        '<button type="button" class="cc-btn2" data-cc-restore>Remettre ces produits au panier</button></div>';
    }
    var ideas = '';
    if (flash.length) ideas += '<div class="cc-esec"><h3>En promo cette semaine</h3>' + flash.map(function (s) {
      return '<div class="cc-eflash"><img src="' + esc(big(s.image)) + '" alt="" width="64" height="64" loading="lazy">' +
        '<div><b>' + esc(s.name) + '</b><span class="cc-eflash-p"><span class="cc-pbadge">−' + s.pct + ' %</span><s>' + money(s.price) + '</s>' + money(s.now) + ' HT</span></div>' +
        eaButton(s, 'promo') + '</div>';
    }).join('') + '</div>';
    if (top.length) ideas += '<div class="cc-esec"><h3>Les plus commandés</h3><div class="cc-egrid">' + top.map(function (s) {
      var choose = s.multi && !has(CFG.pumpOnly, s.productId);
      return '<div class="cc-et"><div class="cc-et-i"><img src="' + esc(big(s.image)) + '" alt="" loading="lazy">' + (s.badge === 'Nouveau' ? '<span class="cc-et-new">Nouveau</span>' : '') + '</div>' +
        '<b>' + esc(s.name) + '</b><small>' + (choose ? 'dès ' : '') + money(s.price) + ' HT</small>' + eaButton(s, 'top') + '</div>';
    }).join('') + '</div></div>';
    if (CFG.gammes.length) ideas += '<div class="cc-esec"><h3>Par gamme</h3><div class="cc-echips">' + CFG.gammes.map(function (g) {
      return '<a href="' + esc(g[1]) + '" data-cc-eg="' + esc(g[0]) + '">' + esc(g[0]) + '</a>';
    }).join('') + '</div></div>';
    return h + (ideas ? '<div class="cc-eideas">' + ideas + '</div>' : '');
  }
  function eaButton(s, bloc) {
    var choose = s.multi && !has(CFG.pumpOnly, s.productId);
    var label = !choose ? PLUS + 'Ajouter' : has(CFG.forceProducts, s.productId) ? 'Forces' : (CFG.units[s.productId] || [])[0] === 'tube' ? 'Nuances' : 'Choisir';
    return '<button type="button" class="cc-eadd" data-cc-ea="' + s.productId + '" data-bloc="' + bloc + '" aria-label="' + (choose ? 'Choisir ' : 'Ajouter ') + esc(s.name) + '">' + label + '</button>';
  }
  // Reprise du dernier panier : un produit devenu indisponible fait échouer tout l'ajout groupé,
  // on reprend alors ligne par ligne. Appels directs : un refus de stock n'est pas une erreur à surveiller.
  function addQuiet(items) {
    return nativeFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.ok; }, function () { return false; });
  }
  function restore() {
    var last = lsGet(LAST_KEY), miss = 0;
    if (!last || !last.items) return;
    T('panier', 'vide_reprise', null, { articles: last.count, lignes: last.items.length });
    run(addQuiet(last.items).then(function (ok) {
      if (ok) return;
      return last.items.reduce(function (p, it) {
        return p.then(function () { return addQuiet([it]).then(function (one) { if (!one) miss++; }); });
      }, Promise.resolve());
    })).then(function () {
      toast(miss ? miss + ' produit' + (miss > 1 ? 's' : '') + ' plus disponible' + (miss > 1 ? 's' : '') : 'Panier repris');
    });
  }

  /* ---------- panneau des variantes ---------- */
  function oxyPrefill(p, qty) {
    var k = stats(), added = 0;
    Object.keys(k.byForce).sort(function (a, b) { return a - b; }).forEach(function (f) {
      var v = p.variants.find(function (x) { return parseInt(x.title, 10) === +f && x.available; });
      if (!v) return;
      var miss = Math.ceil(k.byForce[f] - 1e-9) - (qty[v.id] || 0);
      if (miss > 0) { qty[v.id] = (qty[v.id] || 0) + miss; added += miss; }
    });
    if (!added && k.needL > k.oxy) qty[CFG.oxy.defaultVariantId] = (qty[CFG.oxy.defaultVariantId] || 0) + (k.needL - k.oxy);
  }
  function vpOpen(handle, from, extraVid, extraQty) {
    getProduct(handle).then(function (p) {
      var qty = {};
      visible().forEach(function (i) { if (i.product_id === p.id) qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
      var base = JSON.stringify(qty);
      if (typeof extraVid === 'function') extraVid(p, qty);
      else if (extraVid) qty[extraVid] = (qty[extraVid] || 0) + (extraQty || 1);
      vp = { p: p, qty: qty, base: base, from: from, q: '' };
      var l0 = root.querySelector('.cc-vp-list'); if (l0) l0.scrollTop = 0;
      vpRender();
      var i = root.querySelector('.cc-vp-q'); if (i) i.focus();
    });
  }
  function vpRender() {
    var el = $('.cc-vp');
    if (!vp) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); return; }
    var p = vp.p, q = vp.q.toLowerCase().trim(), isOxy = p.id === CFG.oxy.productId;
    var rows = p.variants.filter(function (v) { return !q || v.title.toLowerCase().indexOf(q) !== -1; });
    var n = 0, bn = 0, clean = {}, bq = JSON.parse(vp.base);
    Object.keys(vp.qty).forEach(function (k) { n += vp.qty[k]; if (vp.qty[k]) clean[k] = vp.qty[k]; });
    Object.keys(bq).forEach(function (k) { bn += bq[k]; });
    var changed = Object.keys(clean).length !== Object.keys(bq).length || Object.keys(clean).some(function (k) { return clean[k] !== bq[k]; });
    var dn = n - bn;
    var tally = '';
    if (isOxy) { var k = stats(); tally = '<div class="cc-vp-tally' + (n >= k.needL ? ' ok' : '') + '"><span>' + String(k.need).replace('.', ',') + ' L nécessaires pour vos mélanges</span><b>' + n + ' / ' + k.needL + ' L</b></div>'; }
    var oldList = el.querySelector('.cc-vp-list'), keepScroll = oldList ? oldList.scrollTop : 0;
    el.innerHTML = '<div class="cc-vp-h"><button type="button" class="cc-x" data-cc-vpclose aria-label="Retour au panier"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M9 2L4 7l5 5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div><small>' + (has(CFG.forceProducts, p.id) ? 'Choisir les forces' : 'Choisir les nuances') + '</small><b>' + esc(nameOf(p.id, p.title)) + '</b></div></div>' + tally +
      (p.variants.length > 12 ? '<div class="cc-vp-s"><input type="search" class="cc-vp-q" placeholder="Numéro ou reflet : 7.3, cendré…" value="' + esc(vp.q) + '" aria-label="Rechercher"></div>' : '') +
      '<div class="cc-vp-list">' + rows.map(function (v) {
        var qq = vp.qty[v.id] || 0, sw = v.featured_image ? img(v.featured_image.src, 60) : '';
        return '<div class="cc-vp-row' + (qq ? ' on' : '') + (sw ? '' : ' nosw') + (v.available ? '' : ' off') + '">' + (sw ? '<img class="cc-sw" src="' + esc(sw) + '" alt="">' : '') +
          '<span class="cc-vp-n' + (has(CFG.forceProducts, p.id) ? ' big' : '') + '">' + esc(cleanVariant(v.title)) + (v.available ? '' : ' <em>épuisé</em>') + vpPrice(p, v) + '</span>' +
          (v.available ? '<span class="cc-step"><button type="button" data-cc-vq="-1" data-vid="' + v.id + '" aria-label="Moins">−</button><span class="cc-qv">' + qq + '</span><button type="button" data-cc-vq="1" data-vid="' + v.id + '" aria-label="Plus">+</button></span>' : '<span></span>') +
          '</div>';
      }).join('') + (rows.length ? '' : '<p class="cc-vp-none">Aucune variante ne correspond.</p>') + '</div>' +
      '<div class="cc-vp-f"><button type="button" class="cc-cta" data-cc-vpapply' + (changed ? '' : ' disabled') + '>' +
      (changed ? 'Mettre à jour' + (dn ? ' · ' + (dn > 0 ? '+' : '−') + Math.abs(dn) + ' ' + unit(p.id, Math.abs(dn)) : '') : 'Aucune modification') + '</button></div>';
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    var newList = el.querySelector('.cc-vp-list'); if (newList && keepScroll) newList.scrollTop = keepScroll;
  }
  // Prix sous chaque variante (produits à forces ou prix barré) ; pas sur les nuanciers à prix unique.
  function vpPrice(p, v) {
    var was = v.compare_at_price > v.price ? v.compare_at_price : 0;
    if (!was && !has(CFG.forceProducts, p.id)) return '';
    return '<span class="cc-vp-p">' + (was ? '<s>' + money(was) + '</s> ' : '') + money(v.price) + ' HT' +
      (was ? ' <span class="cc-pbadge">−' + Math.round((1 - v.price / was) * 100) + ' %</span>' : '') + '</span>';
  }
  function vpApply() {
    var updates = {}, bq = JSON.parse(vp.base), from = vp.from, pid = vp.p.id;
    Object.keys(vp.qty).forEach(function (k) { if ((bq[k] || 0) !== vp.qty[k]) updates[k] = vp.qty[k]; });
    Object.keys(bq).forEach(function (k) { if (!(k in vp.qty)) updates[k] = 0; });
    vp = null; vpRender();
    if (from === 'oc') oc[pid] = true;
    open_[pid] = true;
    run(api('/cart/update.js', { updates: updates })).then(function () { toast('Panier mis à jour'); });
  }

  /* ---------- power-up / power-down ---------- */

  function powerFx(k) {
    var p = prev, free = k.count > 0 && k.sub >= CFG.franco;
    prev = { free: free, disc: k.disc, count: k.count };
    if (!p || quiet || !root.classList.contains('on')) return;
    var fx = [];
    if (!p.free && free) fx.push(['up', '<b>Livraison offerte</b>', '.cc-fs-l']);
    if (p.free && !free && k.count) fx.push(['down', '<b>Livraison</b> +' + money(CFG.shipping) + ' HT', '.cc-fs-l']);
    var dd = k.disc - p.disc;
    if (dd > 0) fx.push(['up', '<b>+' + money(dd) + '</b> d’économies', '.cc-sum-tot b']);
    if (dd < 0 && k.count) fx.push(['down', '<b>−' + money(-dd) + '</b> d’économies', '.cc-sum-tot b']);
    if (!fx.length) return;
    var panel = $('.cc-panel'), R = panel.getBoundingClientRect(), x, y;
    if (lastTap && Date.now() - lastTap.t < 2500) { x = lastTap.x - R.left; y = lastTap.y - R.top - 14; }
    var w = document.createElement('div'); w.className = 'cc-pfx';
    fx.forEach(function (f) {
      var el = document.createElement('span'); el.className = 'cc-pup ' + f[0]; el.innerHTML = f[1]; w.appendChild(el);
      var tg = panel.querySelector(f[2]);
      if (tg) {
        tg.classList.remove('cc-gain', 'cc-loss'); void tg.offsetWidth; tg.classList.add(f[0] === 'up' ? 'cc-gain' : 'cc-loss');
        if (x === undefined) { var tr = tg.getBoundingClientRect(); x = tr.left + tr.width / 2 - R.left; y = tr.top - R.top - 6; }
      }
    });
    x = Math.min(Math.max(x || R.width / 2, 100), R.width - 100); y = Math.max(y || 80, 50);
    w.style.left = x + 'px'; w.style.top = y + 'px';
    panel.appendChild(w);
    setTimeout(function () { w.remove(); }, 1800);
  }  var toastT;
  function toast(m) { var t = $('.cc-toast'); t.textContent = m; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 1600); }

  /* ---------- ouverture ---------- */
  function open() {
    if (!root.classList.contains('on')) T('panier', 'ouverture', location.pathname, { articles: cart ? cart.item_count : null });
    root.classList.add('on');
    root.setAttribute('aria-hidden', 'false');
    // Sur ordinateur la page reste défilable derrière le panier ; sur mobile il couvre l'écran.
    if (window.matchMedia('(max-width: 749px)').matches) document.documentElement.classList.add('cc-lock');
    sync(true);
  }
  function close() {
    vp = null; vpRender();
    root.classList.remove('on');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cc-lock');
  }

  /* ---------- événements ---------- */
  root.addEventListener('pointerdown', function (e) { lastTap = { x: e.clientX, y: e.clientY, t: Date.now() }; }, true);
  root.addEventListener('click', function (e) {
    var t = e.target, b;
    if (t.closest('[data-cc-close]')) return close();
    if (t.closest('[data-cc-vpclose]')) { vp = null; return vpRender(); }
    if ((b = t.closest('[data-cc-vq]'))) {
      var vid = b.dataset.vid; vp.qty[vid] = Math.max(0, (vp.qty[vid] || 0) + (+b.dataset.ccVq)); if (!vp.qty[vid]) delete vp.qty[vid];
      return vpRender();
    }
    if (t.closest('[data-cc-vpapply]')) return vpApply();
    if (!cart) return;
    if ((b = t.closest('[data-cc-vp]'))) {
      e.preventDefault(); e.stopPropagation();
      return vpOpen(b.dataset.ccVp, b.dataset.from || 'line', b.dataset.vid ? +b.dataset.vid : null, 1);
    }
    if (t.closest('[data-cc-oxyadd]')) {
      var pl = oxyPlan(stats());
      if (pl && pl.length) return run(api('/cart/add.js', { items: pl.map(function (x) { return { id: x.id, quantity: x.quantity }; }) }));
      return vpOpen(CFG.oxy.handle, 'oxy', oxyPrefill);
    }
    if (t.closest('[data-cc-oxy]')) return vpOpen(CFG.oxy.handle, 'oxy', oxyPrefill);
    if (t.closest('[data-cc-restore]')) return restore();
    var eti = t.closest('.cc-et-i');
    if ((b = t.closest('[data-cc-ea]') || (eti && eti.parentNode.querySelector('[data-cc-ea]')))) {
      var epid = +b.dataset.ccEa, edef = CFG.flash.concat(CFG.strip).filter(function (x) { return x.productId === epid; })[0];
      if (!edef) return;
      var choose = edef.multi && !has(CFG.pumpOnly, epid);
      T('panier', choose ? 'vide_choisir' : 'vide_ajout', edef.name, { produit_id: epid, bloc: b.dataset.bloc });
      if (choose) return vpOpen(edef.handle, 'vide');
      return run(api('/cart/add.js', { items: [{ id: edef.variantId, quantity: 1 }] })).then(function () { toast(edef.name + ' ajouté'); });
    }
    if ((b = t.closest('[data-cc-eg]'))) return T('panier', 'vide_gamme', b.dataset.ccEg, { href: b.getAttribute('href') });
    if (t.closest('[data-cc-ex]')) return T('panier', 'vide_express', null, {});
    var rci = t.closest('.cc-rc-i');
    if ((b = t.closest('[data-cc-rc]') || (rci && rci.querySelector('[data-cc-rc]')))) {
      var rpid = +b.dataset.ccRc, rvid = +b.dataset.vid;
      if (b.closest('.cc-rc.on')) {
        delete oc[rpid];
        var rups = {};
        visible().forEach(function (i) { if (i.product_id === rpid) rups[i.key] = 0; });
        return run(api('/cart/update.js', { updates: rups }));
      }
      var rdef = CFG.flash.concat(CFG.strip).filter(function (x) { return x.productId === rpid; })[0];
      if (rdef && rdef.multi && !has(CFG.pumpOnly, rpid)) return vpOpen(rdef.handle, 'oc');
      oc[rpid] = true;
      return run(api('/cart/add.js', { items: [{ id: rvid, quantity: 1 }] }));
    }
    if ((b = t.closest('[data-cc-forgot]'))) return run(api('/cart/add.js', { items: [{ id: +b.dataset.ccForgot, quantity: 1 }] }));
    if ((b = t.closest('[data-cc-addq]'))) return run(api('/cart/add.js', { items: [{ id: +b.dataset.ccAddq, quantity: +b.dataset.q }] }));
    if ((b = t.closest('[data-cc-tog]'))) { open_[b.dataset.ccTog] = !open_[b.dataset.ccTog]; return render(); }
    if ((b = t.closest('[data-cc-q]'))) {
      var item = cart.items.filter(function (i) { return i.key === b.dataset.key; })[0];
      if (item) {
        var want = Math.max(0, item.quantity + (+b.dataset.ccQ)), mxq = maxOf(item.product_id);
        if (mxq && want > mxq) { toast('Maximum ' + mxq + ' par commande'); return; }
        run(api('/cart/change.js', { id: item.key, quantity: want }));
      }
      return;
    }
    if ((b = t.closest('[data-cc-rm]'))) {
      var ups = {};
      b.dataset.ccRm.split(',').forEach(function (key) { ups[key] = 0; });
      return run(api('/cart/update.js', { updates: ups }));
    }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.ccOc) {
      var pid = +t.dataset.ccOc, vid = +t.dataset.vid;
      var def = CFG.strip.filter(function (x) { return x.productId === pid; })[0];
      if (t.checked && def && def.multi && !has(CFG.pumpOnly, pid)) { t.checked = false; return vpOpen(def.handle, 'oc'); }
      if (t.checked) { oc[pid] = true; run(api('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })); }
      else {
        delete oc[pid];
        var ups = {};
        visible().forEach(function (i) { if (i.product_id === pid) ups[i.key] = 0; });
        run(api('/cart/update.js', { updates: ups }));
      }
    }
  });
  root.addEventListener('input', function (e) {
    if (e.target.classList.contains('cc-vp-q') && vp) {
      vp.q = e.target.value; var pos = e.target.selectionStart; vpRender();
      var i = root.querySelector('.cc-vp-q'); if (i) { i.focus(); try { i.setSelectionRange(pos, pos); } catch (_) {} }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !root.classList.contains('on')) return;
    if (vp) { vp = null; vpRender(); } else close();
  });

  // Icône panier du header : ouvre le panier au lieu d'aller sur /cart.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"], #cart-icon-bubble');
    if (!a || root.contains(a)) return;
    e.preventDefault();
    open();
  }, true);

  // Tout ajout au panier (fiche produit, Replo, pages promo) ouvre le panier.
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url)); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = nativeFetch(input, init);
    if (isAdd(url)) p.then(function (r) { if (r.ok) setTimeout(open, 50); });
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isAdd(url)) this.addEventListener('load', function () { if (this.status < 400) setTimeout(open, 50); });
    return xhrOpen.apply(this, arguments);
  };

  var WARN = '<svg width="16" height="14" viewBox="0 0 18 16" aria-hidden="true"><path d="M9 1.2L17 15H1z" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 6v4.2" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><circle cx="9" cy="12.6" r="1" fill="#fff"/></svg>';

  // Bloc Navidium : son titre et son lien « sans assurance » sont masqués,
  // on affiche à la place une ligne sous le bouton qui déclenche son vrai lien.
  function syncIns() {
    var line = $('.cc-ins'), price = root.querySelector('.nvd-mini .nvd-title span'), noins = root.querySelector('#nvd-without-checkout-btn');
    if (!price || !noins) { line.hidden = true; return; }
    var v = parseFloat(price.textContent.replace(/[^\d,.]/g, '').replace(',', '.'));
    $('.cc-ins-p').textContent = isNaN(v) ? price.textContent.trim() : money(Math.round(v * 100));
    line.hidden = false;
  }
  new MutationObserver(syncIns).observe(root.querySelector('.nvd-mini'), { childList: true, subtree: true, characterData: true });
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cc-noins]')) return;
    var noins = root.querySelector('#nvd-without-checkout-btn');
    if (noins) noins.click();
  });

  // Les autres apps (BOGOS, Navidium…) modifient aussi le panier : on se resynchronise
  // dès qu'une requête de modification passe et que le contenu réel a changé.
  function signature(c) { return c ? c.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|') + '#' + c.total_price : ''; }
  var extTimer;
  if (window.PerformanceObserver) {
    new PerformanceObserver(function (list) {
      var hit = list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(e.name); });
      if (!hit || !root.classList.contains('on')) return;
      clearTimeout(extTimer);
      extTimer = setTimeout(function check() {
        if (busy) { extTimer = setTimeout(check, 400); return; }
        getCart().then(function (c) {
          if (signature(c) === signature(cart)) return;
          return ensureGasoil(c).then(function (c2) { cart = c2; render(); });
        });
      }, 900);
    }).observe({ entryTypes: ['resource'] });
  }

  /* ---------- client ouvert depuis l'extension CRM ---------- */
  // La Commande express mémorise le checkout pré-rempli avec l'adresse de la cliente (cc_crm_checkout).
  // Navidium ajoute d'abord sa protection puis, avec nvdStopRedirect, clique le bouton de paiement du panier
  // au lieu d'aller sur /checkout : ce clic part vers le checkout pré-rempli (taxe et protection déjà au panier).
  // Seulement si le panier est toujours celui créé pour la cliente CRM (jeton mémorisé par la Commande express) :
  // un autre panier repris dans le même onglet part vers le checkout normal, avec ses propres coordonnées.
  var crmUrl = null; try { crmUrl = sessionStorage.getItem('cc_crm_checkout'); } catch (e) {}
  function crmActive() {
    var own = null; try { own = sessionStorage.getItem('cc_crm_cart'); } catch (e) {}
    return !!(crmUrl && own && cart && String(cart.token || '').split('?')[0] === own);
  }
  if (crmUrl) {
    window.nvdStopRedirect = true;
    window.nvdStopJSTrigger = true; // sinon Navidium redirige au clic sans ajouter la protection
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[name="checkout"]') || !crmActive()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      location.assign(crmUrl);
    }, true);
  }

  window.ccCart = { open: open, close: close, sync: sync };

  // Pages promo générées (FULLBLOND, EASYBLOND, lancement…) : elles ajoutent au panier sans
  // l'ouvrir et pilotent l'ancien Corner Cart. Sans Corner Cart, on répond à sa place :
  // « Voir mon panier » ouvre notre panier, les fermetures automatiques après ajout sont ignorées.
  if (!window.corner || typeof window.corner.do !== 'function') {
    window.corner = { do: function (action) {
      if (action === 'openCart') open();
      else if (action === 'refreshCart' && root.classList.contains('on')) sync();
    } };
  }

  if (location.pathname === '/cart') open();
  else getCart().then(ensureFees);
})();
